import { useMutation, useQueries, useQueryClient } from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axiosInstanceV2 from "@lhd/libs/axiosV2";
import { getCompanyId } from "@lhd/utility";
import { useMemo } from "react";
import { fetchSalaryWorkers } from "./salaryWorkers";

const fetchWorks = async (
  year: any,
  companyId: any,
  // unitType?: "day" | "time",
) => {
  return await axiosInstanceV2({
    method: "get",
    url: SERVICES.WORKS,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      "q[year_cycle_eq]": year,
      // "q[unit_type_eq]": unitType || "day",
    },
  }).then((res) => res.data || []);
};

const fetchWorkColumns = async (companyId: any) => {
  return await axiosInstanceV2({
    method: "get",
    url: SERVICES.WORK_COLUMNS,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
    },
  }).then((res) => res.data || []);
};

export const useConfigs = (year: unknown) => {
  return useMemo(
    () => ({
      staleTime: 0,
      cacheTime: 300000,
      retry: 1,
      enabled: !!year,
    }),
    [year],
  );
};

// export const usePromiseSettledWorks = (year: any, unitType: "day" | "time") => {
export const usePromiseSettledWorks = (year: any) => {
  const companyId = getCompanyId();
  const queryConfig = useConfigs(year);

  return useQueries({
    queries: [
      {
        queryKey: ["QUERY_NAME.WORKS", 1, year, companyId, year],
        queryFn: () => fetchWorks(year, companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.WORKS", 2, companyId, year],
        queryFn: () => fetchWorkColumns(companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.WORKS", 3, companyId, year],
        queryFn: () => fetchSalaryWorkers(companyId),
        ...queryConfig,
      },
    ],
  });
};

export const useSubmitWorks = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload }: any) =>
      axiosInstanceV2({
        method: "post",
        url: SERVICES.WORKS_SAVE,
        data: payload,
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.WORKS]);
        // notification["success"]({
        //   message: "保存しました",
        // });
      },
    },
  );
};
